type YAxisTickProps = {
    x?: number;
    y?: number;
    payload?: { value: string | number };
    formatValue?: (value: string | number) => string | number;
    textAnchor?: "end" | "start" | "middle" | "inherit";
};

export const YAxisTick: React.FC<YAxisTickProps> = ({
    x = 0,
    y = 0,
    payload = { value: "" },
    formatValue,
    textAnchor = "end",
}) => {
    const displayValue = formatValue ? formatValue(payload.value) : payload.value;

    return (
        <g transform={`translate(${x},${y + 8})`}>
            <text
                x={-10}
                y={-2}
                dy={0}
                textAnchor={textAnchor}
                fill="var(--ds-color-neutral-text-subtle)"
                fontSize={"var(--ds-font-size-1)"}
            >
                {displayValue}
            </text>
        </g>
    );
};
